export default "__VITE_ASSET__Bh6eml3H__"